import Vue from "vue";
import App from "./App";
import router from "./router";

import h5PublicApi from "./app/script/public.js";
import h5PowerApi from "./app/script/power.js";

import ElementUI from "element-ui";
import "@/pc/assets/css/theme/index.css";
// import "element-ui/lib/theme-chalk/index.css";

// 富文本编辑器
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
Vue.use(quillEditor)

// 测试身份
if (process.env.NODE_ENV === "development") {
	h5PublicApi.cookieData(
		"set",
		"Authorization",
		"9171cf20114e00eed3828fdff8a572c7"
	);
}

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.prototype.msgSuccess = function (msg) {
	this.$message({ showClose: true, message: msg, type: "success" });
};
Vue.prototype.msgError = function (msg) {
	this.$message({ showClose: true, message: msg, type: "error" });
};
Vue.prototype.msgWarning = function (msg) {
	this.$message({ showClose: true, message: msg, type: "warning" });
};
Vue.prototype.msgInfo = function (msg) {
	this.$message.info(msg);
};

import htmlToPdf from "@/pc/utils/htmlToPdf";
Vue.use(htmlToPdf);

console.log(process.env.NODE_ENV, h5PublicApi.cookieData("get", "Authorization"))
// console.log(window.location.search)
let params = window.location.search && window.location.search.replace('?', '').split('=');
if (params[0] == 'isAnonSubmit' && params[1] == 0) {
	sessionStorage.setItem('isAnonSubmit', params[1])
	Vue.use(ElementUI);

	Vue.config.productionTip = false;
	new Vue({
		el: "#app",
		router,
		components: { App },
		template: "<App/>"
	});

	Vue.prototype.h5Ajax = h5PublicApi.ajax;
	Vue.prototype.h5AjaxUpload = h5PublicApi.ajax_upload;
	Vue.prototype.h5AjaxDownload = h5PublicApi.ajax_download;

	// 初始化权限
	Vue.prototype.$h5Power = h5PowerApi.getPower();
	Vue.prototype.$h5Userid = "";
	Vue.prototype.$h5Role = "";
	Vue.prototype.$h5RoleName = "";
	Vue.prototype.$h5AgreeLegal = false;

	router.beforeEach((to, from, next) => {
		// 路由发生变化修改页面title
		if (to.meta.title) {
			document.title = to.meta.title;
		}

		next();
	});
} else {
	if (!h5PublicApi.cookieData("get", "Authorization")) {
		/* if(process.env.NODE_ENV === "development"){
			window.location.href =
				"https://ppnlite.porsche.com/ppnmda/appforward.do?cn=training_tasks_platform_pcn";
		} */
		if (process.env.NODE_ENV === "production") {
			window.location.href =
				"https://ppn.porsche.com/ppnmda/appforward.do?cn=training_tasks_platform_pcn";
		} else if (process.env.NODE_ENV === "testing") {
			window.location.href =
				"https://ppnlite.porsche.com/ppnmda/appforward.do?cn=training_tasks_platform_pcn";
		}

		// 本地开发环境，不需要跳转
	} else {
		Vue.prototype.h5Ajax = h5PublicApi.ajax;
		Vue.prototype.h5AjaxUpload = h5PublicApi.ajax_upload;
		Vue.prototype.h5AjaxDownload = h5PublicApi.ajax_download;

		// 初始化权限
		Vue.prototype.$h5Power = h5PowerApi.getPower();
		Vue.prototype.$h5Userid = "";
		Vue.prototype.$h5Role = "";
		Vue.prototype.$h5RoleName = "";
		Vue.prototype.$h5AgreeLegal = false;

		window.userAuthorization = h5PublicApi.cookieData(
			"get",
			"Authorization"
		);
		h5PublicApi
			.ajax("get", "$/user/info", {}, true, null, true)
			.then(r => {
				// 获取登录用户详细信息
				if (r.code === 201) {
					// 用户信息已过期
					h5PublicApi.cookieData("remove");
					location.reload();

					return;
				}

				var p = {
					vacationer: "guest", // 游客
					dealer: "user", // 经销商
					counselor: "instructor", // 辅导员
					teacher: "teacher", // 培训中心老师
					administrator: "admin" // 超级管理员
				};
				var roles = {
					vacationer: "游客",
					dealer: "经销商",
					counselor: "辅导员",
					teacher: "培训中心老师",
					administrator: "超级管理员"
				};
				Vue.use(ElementUI);

				Vue.config.productionTip = false;
				new Vue({
					el: "#app",
					router,
					components: { App },
					template: "<App/>"
				});

				Vue.prototype.$h5Power = h5PowerApi.getPower(p[r.roles]);
				Vue.prototype.$h5Userid = r.userId;
				sessionStorage.setItem("userId", r.userId);
				sessionStorage.setItem("role", r.roles);
				sessionStorage.setItem("roleName", r.roleName);
				sessionStorage.setItem('username', r.username);
				Vue.prototype.$h5Role = roles[r.roles];
				Vue.prototype.$h5RoleName = r.roleName;

				Vue.prototype.$h5AgreeLegal = r.declaration == 1;

				if (
					Vue.prototype.$h5Power === "admin" &&
					window.name === "app"
				) {
					Vue.prototype.$h5Power = "teacher";
				}

				console.log("当前用户身份：【" + Vue.prototype.$h5Role + "】");
			})
			.catch(err => {
				console.error("err:" + err);
				//
				// h5PublicApi.cookieData('remove');
				// location.reload();
			});

		router.beforeEach((to, from, next) => {
			// 路由发生变化修改页面title
			if (to.meta.title) {
				document.title = to.meta.title;
			}

			next();
		});
	}
}



// WEBPACK FOOTER //
// ./src/main.js